import Dexie from "dexie";
import { SegmentRow } from "../SegmentationMapping/SegmentationLabeling";
import { SotGa4MappingRow } from "../SotGa4MappingTool/SotGa4MappingTool";

export interface EditRecord {
  id?: number;
  cid: string;
  campaignKey: string;
  batchType: "labeled" | "unlabeled";
  rowData: SegmentRow;
  timestamp: number;
}

export class DexieDB extends Dexie {
  editRecords!: Dexie.Table<EditRecord, number>;

  constructor() {
    super("DexieDB");
    this.version(1).stores({
      editRecords: "++id, cid, campaignKey, batchType, rowData, timestamp",
    });
  }
}

export const db = new DexieDB();

export interface SotGa4EditRecord {
  id?: number;
  cid: string;
  campaignKey: string;
  batchType: "labeled" | "unlabeled";
  rowData: SotGa4MappingRow;
  timestamp: number;
}

export class DexieDBSotGa4 extends Dexie {
  editRecords!: Dexie.Table<SotGa4EditRecord, number>;

  constructor() {
    super("DexieDB");
    this.version(1).stores({
      editRecords: "++id, cid, campaignKey, batchType, rowData, timestamp",
    });
  }
}

export const dbSotGa4 = new DexieDBSotGa4();
